module.exports = __webpack_public_path__ + "media/images/ppt_icon-595731e4af842a5677d133b0c2112a14.png";